import Swiper from 'swiper';
import { Thumbs, Keyboard } from 'swiper/modules';

/**
 * @class Artworks slider
 *   
 * @method constructor
 *     @param {HTMLElement} el
 *
 * Create a slider for artworks with thumbnails
 */
export default class ArtworksSlider {
    constructor (el) {
        this.el = el;
        const thumbs = document.querySelector(this.el.dataset.thumbs);

        this.thumbs = new Swiper(thumbs, {
            modules: [Thumbs],
            slidesPerView: 4,
            spaceBetween: 22,
            watchSlidesProgress: true
        });

        this.slider = new Swiper(this.el, {
            modules: [Thumbs, Keyboard],
            duration: 300,
            grabCursor: true,
            keyboard: true,
            thumbs: {
                swiper: thumbs
            }
        });
    }
}
